<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Activation Report" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
		
							<div class="col-md-12 project-list filter-sort">
                                <div class="row">
                                    <div class="col-md-12 d-flex justify-content-end align-items-center mt-3">
                                        <div class="btn btn-info" v-if="Boolean(reports.length)" @click="generateExcel()">Download</div>
                                    </div>
                                </div>
                            </div>

						</div>
					</div>

					<div class="card">
						<div class="card-body">

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
									<tr align="center">
										<th>ICCID</th>
										<th>MSISDN 1</th>
                                        <th>IMSI 1</th>
                                        <th>MSISDN 2</th>
                                        <th>IMSI 2</th>
										<th>Operator 1</th>
                                        <th>Operator 2</th>
										<th>Network Mode</th> 
									</tr>
									</thead>
									<tbody v-if="Boolean(reports.length)">
										<tr v-for="(report, index) in reports" :key="report.id" align="center">
											<td>{{report.primary_ICCID}}</td>
											<td>{{report.primary_MSISDN}}</td>
											<td>{{report.primary_IMSI}}</td>
											<td>{{report.secondary_MSISDN}}</td>
											<td>{{report.secondary_IMSI}}</td>
											<td>{{report.primary_SIM}}</td>
											<td>{{report.secondary_SIM}}</td>
											<td>{{report.action.action_name}}</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="8" class="text-center">No Activation Data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchActivationReport(page.url  + '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
		
						</div>
					</div>
				</div>
			</div>
		</div>
 
 
	  
   </div>
</template>


<script>

	export default {
		name: "ActivationReport",
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,	

				reports: [],	
				action: "",	
				profile: "",		
			};
		},
		mounted() {},

		created() {
			this.fetchActivationReport();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchActivationReport(page_url = null) {
				this.getToken();
				let url = "/trazio/activationReport?limit=" + this.listing_length;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.reports = responseData.records.data;
						this.pagination = responseData.records.links;
						this.from = responseData.records.from;
						this.to = responseData.records.to;
						this.total = responseData.records.total;
					})
					.catch((err) => console.log(err));
			},

			generateExcel() {
				this.getToken();
				
				const url = `/trazio/activationReportDownload`;

				this.$axios
					.get(url, {
					headers: {
						Authorization: "Bearer " + this.token,
					},
					responseType: "arraybuffer", // for binary file
					})
					.then((response) => {
					const blob = new Blob([response.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
					});

					const now = new Date();
					const datePart = now.toISOString().slice(0, 10); // e.g., 2025-06-30
					const timePart = now.toTimeString().slice(0, 8).replace(/:/g, "-"); // e.g., 14-35-22

					const fileName = `activation_report_${datePart}_${timePart}.xlsx`;

					const link = document.createElement("a");
					link.href = URL.createObjectURL(blob);
					link.download = fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					})
					.catch((err) => console.log(err));
			}



		},
	};
</script>
